var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.481 0H8.53333C3.08622 0 0 3.08622 0 8.53333V23.4667C0 28.9138 3.08622 32 8.53333 32H23.481C28.928 32 32 28.9138 32 23.4667V8.53333C32 3.08622 28.928 0 23.481 0Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0016 12.2598C18.5639 12.2598 17.3359 12.4864 17.3359 13.3931C17.3359 14.3001 18.5563 14.5348 20.0016 14.5348C21.4393 14.5348 22.6673 14.3084 22.6673 13.4014C22.6673 12.4944 21.4473 12.2598 20.0016 12.2598Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.9984 11.3952C20.9777 11.3952 21.7624 10.6102 21.7624 9.63119C21.7624 8.65219 20.9777 7.86719 19.9984 7.86719C19.0194 7.86719 18.2344 8.65219 18.2344 9.63119C18.2344 10.6102 19.0194 11.3952 19.9984 11.3952Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0016 21.8594C10.5639 21.8594 9.33594 22.086 9.33594 22.9927C9.33594 23.8997 10.5563 24.1344 12.0016 24.1344C13.4393 24.1344 14.6673 23.908 14.6673 23.001C14.6673 22.094 13.4473 21.8594 12.0016 21.8594Z",
    fill: "#CE2600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.9984 20.9948C12.9777 20.9948 13.7624 20.2098 13.7624 19.2308C13.7624 18.2518 12.9777 17.4668 11.9984 17.4668C11.0194 17.4668 10.2344 18.2518 10.2344 19.2308C10.2344 20.2098 11.0194 20.9948 11.9984 20.9948Z",
    fill: "#CE2600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.9984 18.4004C23.9984 21.4964 21.4944 24.0004 18.3984 24.0004L19.2384 22.6004",
    stroke: "#CE2600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8 13.6C8 10.504 10.504 8 13.6 8L12.76 9.4",
    stroke: "#CE2600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.8dc2dcbe0b8685bd7219c76d68e6bace.svg";
export { ForwardRef as ReactComponent };